import { render, staticRenderFns } from "./roleRouteSelect.vue?vue&type=template&id=e5e9dcf4&scoped=true&"
import script from "./roleRouteSelect.vue?vue&type=script&lang=js&"
export * from "./roleRouteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e9dcf4",
  null
  
)

export default component.exports